import { Box, BoxProps, InputAdornment } from "@mui/material";
import { TextFieldProps } from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { SearchBox } from "@buildwitt/shapeshift-common/v1/searchBox";

interface IPropsCustom {
	value: string;
	onChange: (value: string) => void;
	textFieldProps?: TextFieldProps;
}

export type IProps = Omit<BoxProps, "onChange"> & IPropsCustom;

const useStyles = makeStyles()((theme) => ({
	librarySearch: {
		margin: "10px",
		gap: "10px",
		display: "flex",
		[theme.breakpoints.down("sm")]: {
			flexDirection: "column"
		},
		"& > *": {
			height: "43px"
		}
	},
	searchBox: {
		margin: "0",
		flexGrow: "2"
	}
}));

/**
 * Simplified LibrarySearch: search box only, no instructor or tag selects.
 * Matches legacy LibrarySearch layout and styling for the search box portion.
 */
export const SimplifiedLibrarySearch: FC<IProps> = ({
	className,
	value,
	onChange,
	textFieldProps,
	...props
}) => {
	const { classes, cx } = useStyles();

	return (
		<Box className={cx(classes.librarySearch, className)} {...props}>
			<SearchBox
				className={classes.searchBox}
				value={value}
				onChange={(e) => onChange(e.target.value ?? "")}
				{...textFieldProps}
				InputProps={{
					...textFieldProps?.InputProps,
					startAdornment: (
						<InputAdornment position="start">
							<SearchIcon />
						</InputAdornment>
					),
				}}
			/>
		</Box>
	);
};

export default SimplifiedLibrarySearch;
